import { useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { runInAction } from 'mobx'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { ContentThumbnail } from 'modules/trainings/components/content/items/shared/fields/ContentThumbnail'
import { InlineEditableContent } from 'modules/trainings/components/content/items/shared/fields/InlineEditableContent'
import { ContentRenderProps } from 'modules/trainings/components/content/types'
import { AttachedFile } from 'modules/trainings/lib/content/AttachedFile'
import { PageBlock } from 'modules/trainings/lib/content/PageBlock'

export const PageBlockView = observer(
  ({ contentItem, readOnly = false, onContentChange }: ContentRenderProps<PageBlock>) => {
    const { id: trainingId } = useParams()

    const handleTitleChange = (value: string) => {
      runInAction(() => {
        contentItem.title = value
      })
      onContentChange?.()
    }

    const handleDescriptionChange = (value: string) => {
      runInAction(() => {
        contentItem.description = value
      })
      onContentChange?.()
    }

    const handleThumbnailChange = (thumbnail: AttachedFile) => {
      runInAction(() => {
        contentItem.thumbnail = thumbnail
      })
      onContentChange?.()
    }

    const handleThumbnailDelete = () => {
      runInAction(() => {
        contentItem.thumbnail.clear()
      })
      onContentChange?.()
    }

    return (
      <Box gap="s16" width="full" alignItems="center" paddingTop="s8">
        <ContentThumbnail
          thumbnail={contentItem.thumbnail}
          readOnly={readOnly}
          trainingId={trainingId || ''}
          description={i18n.t('trainings.content.block.page.thumbnail_description')}
          title={contentItem.title}
          onChange={handleThumbnailChange}
          onDelete={handleThumbnailDelete}
        />
        <InlineEditableContent
          key={contentItem.uuid}
          value={contentItem.description}
          readOnly={readOnly}
          placeholder={i18n.t('trainings.content.block.page.description_placeholder')}
          onChange={handleDescriptionChange}
          title={contentItem.title}
          onTitleChange={handleTitleChange}
          titlePlaceholder={i18n.t('trainings.content.block.page.title_placeholder')}
          trainingId={String(trainingId)}
        />
      </Box>
    )
  }
)
